export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 750);
}

export async function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

export async function exportPhotoBlob(blob, { format = "jpg", filename = "lenspro-photo" } = {}) {
  if (format === "png" && blob.type !== "image/png") {
    const bitmap = await createImageBitmap(blob);
    const canvas = document.createElement("canvas");
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(bitmap, 0, 0);
    bitmap.close?.();
    const png = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
    downloadBlob(png, `${filename}.png`);
    return png;
  }
  downloadBlob(blob, `${filename}.${format === "jpg" ? "jpg" : format}`);
  return blob;
}

export async function shareBlob(blob, title = "LensPro export") {
  const file = new File([blob], "lenspro-photo.jpg", { type: blob.type || "image/jpeg" });
  if (navigator.canShare?.({ files: [file] })) {
    await navigator.share({ title, files: [file] });
    return true;
  }
  return false;
}

export async function exportPdfFromImage(blob, filename = "lenspro-document.pdf") {
  const { jsPDF } = await import("jspdf");
  const dataUrl = await blobToDataUrl(blob);
  const image = await new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.src = dataUrl;
  });
  const pdf = new jsPDF({
    orientation: image.width > image.height ? "landscape" : "portrait",
    unit: "px",
    format: [image.width, image.height]
  });
  pdf.addImage(dataUrl, blob.type === "image/png" ? "PNG" : "JPEG", 0, 0, image.width, image.height);
  pdf.save(filename);
}

export function exportCsv(rows, filename = "lenspro-export.csv") {
  const headers = Object.keys(rows[0] || { item: "", value: "" });
  const csv = [
    headers.join(","),
    ...rows.map((row) => headers.map((key) => JSON.stringify(row[key] ?? "")).join(","))
  ].join("\n");
  downloadBlob(new Blob([csv], { type: "text/csv;charset=utf-8" }), filename);
}
